(function () {

    const initComplementaryAddToCartButtons = function(mutationsList, observer) {

		let addToCartButtons = document.querySelectorAll('.complementary-add-to-cart');

		if(addToCartButtons.length > 0) {
			for(let button of addToCartButtons) {

				button.addEventListener('click', (e) => {;

					var itemsToAdd = [{
						'id': e.currentTarget.dataset.idproduct,
						'quantity': 1
						}];

					let formData = {
						'items': itemsToAdd
					};

					fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(formData)
					})
					.then(response => {
	
						window.location.reload();
					})
					.catch((error) => {
						console.error('Error:', error);
					});

				});
			}
		}
	}

    const complementaryList = document.querySelector('.complementary-products');
	const observer = new MutationObserver(initComplementaryAddToCartButtons);

	if (complementaryList) {
		observer.observe(complementaryList, { childList: true });
	}
})();